import { Button, DialogActions, type DialogActionsProps, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';

import { BUTTON_SX } from '~/theme';

type ActionButton = {
  label: string;
  enabled?: boolean;
  loading?: boolean;
};
export type IDialogBackNextActionButtons = {
  back?: ActionButton;
  next?: ActionButton;
  skip?: ActionButton;
};

interface IDialogBackNextActionsProps extends Omit<DialogActionsProps, 'children'> {
  onBack: () => void;
  onNext?: () => void;
  onSkip?: () => void;
  nextDisabled?: boolean;
  actionBtns?: IDialogBackNextActionButtons;
}

const DialogBackNextActions = ({
  onBack,
  onNext,
  onSkip,
  nextDisabled,
  actionBtns = {
    back: { label: 'Back', enabled: true },
    next: { label: 'Next', enabled: true },
    skip: { label: 'Skip', enabled: true },
  },
  sx,
  ...props
}: IDialogBackNextActionsProps) => {
  const theme = useTheme();
  // Every dialog in the upload flow (and the manual-entry forms behind it) ends
  // in this footer, so the pill lands on all of them from here.
  const pillSx = BUTTON_SX;

  return (
    <DialogActions
      {...props}
      sx={{
        marginX: theme.spacing(1),
        marginBottom: theme.spacing(1),
        display: 'flex',
        justifyContent: actionBtns.back ? 'space-between' : 'flex-end',
        ...sx,
      }}
    >
      {actionBtns.back ? (
        <Button
          type="button"
          disabled={!actionBtns.back.enabled}
          onClick={onBack}
          color="primary"
          sx={pillSx}
        >
          {actionBtns.back.label}
        </Button>
      ) : null}

      <Grid>
        {actionBtns.skip ? (
          <Button
            type="button"
            onClick={onSkip}
            color="primary"
            variant="outlined"
            disabled={!actionBtns.skip.enabled}
            sx={{ marginRight: theme.spacing(1), ...pillSx }}
          >
            {actionBtns.skip.label}
          </Button>
        ) : null}

        {actionBtns.next ? (
          <Button
            type="submit"
            onClick={onNext}
            color="primary"
            variant="contained"
            disabled={actionBtns.next.enabled === false}
            loading={actionBtns.next.loading}
            sx={pillSx}
          >
            {actionBtns.next.label}
          </Button>
        ) : null}
      </Grid>
    </DialogActions>
  );
};
export default DialogBackNextActions;
